export enum SendStream {
    MEALS_SUMMARY, BILLING
}